import BaseAPI from '@/apis/base'
import { apis, getApiUrl } from '../api-config'

class UserOptionAPI extends BaseAPI {}

export default new UserOptionAPI('v1/user-options', 'UserOption', getApiUrl(apis.CommonAPI))
